// extracted by mini-css-extract-plugin
export default {"root":"ButtonContent-root_J3enF"};